import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Course from "./pages/Course";
import Privacy from "./pages/Privacy";
import MediaKitGenerator from "./pages/MediaKitGenerator";
import MediaKitGenerator2 from "./pages/MediaKitGenerator_v2";
import MediaKitPremium from "./pages/MediaKitPremium";
import Newsletter from "./pages/Newsletter";
import NotFound from "./pages/NotFound";
import ArtistSwipeProfiler from "./pages/ArtistSwipeProfiler";
import { useConsent } from "./consent/ConsentContext";

import "./styles.css";

import { ConsentProvider } from "./consent/ConsentContext";
import CookieBanner from "./components/CookieBanner";
import PosthogGate from "./analytics/PosthogGate";

function AppContent() {
  const location = useLocation();
  const { consent } = useConsent();

  const hideSiteChrome =
   location.pathname === "/swipe" ||
    location.pathname === "/swipe/" ||
    location.pathname === "/mediakit/generator" ||
    location.pathname === "/mediakit/generator/" ||
    location.pathname === "/mediakit/premium" ||
    location.pathname === "/mediakit/premium/";

  useEffect(() => {
    if (!consent?.analytics) return;
    const ph = window.posthog;
    if (!ph || typeof ph.capture !== "function") return;

    ph.capture("$pageview", {
      path: location.pathname,
      search: location.search,
      title: document.title,
      url: window.location.href,
      referrer: document.referrer || null,
    });
  }, [consent?.analytics, location.pathname, location.search]);

  return (
    <>
      {!hideSiteChrome && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mediakit" element={<Home />} />
        <Route path="/mediakit//3Fy9" element={<MediaKitGenerator />} />
        <Route path="/mediakit/generator" element={<MediaKitGenerator2 />} />
        <Route path="/mediakit/premium" element={<MediaKitPremium />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/kurs/:slug" element={<Course />} />
        <Route path="/swipe" element={<ArtistSwipeProfiler />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {!hideSiteChrome && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <ConsentProvider>
      {/* ✅ lädt/stoppt PostHog je nach Einwilligung */}
      <PosthogGate />

      {/* ✅ Banner (am besten auf ALLEN Seiten anzeigen) */}
      <CookieBanner />

      <AppContent />
    </ConsentProvider>
  );
}
